import { computed, get } from "@ember/object"
import Component from "@glimmer/component"
import _ from "lodash"

export default class CspStandardComponent extends Component {
  @computed("standard.description")
  get textToCopy() {
    var statementNotation = get(this, "args.standard.statementNotation") || ""
    return [statementNotation, get(this, "args.standard.description")].join(" ")
  }

  @computed("args.selectedStandardIds.[]", "args.standard.id")
  get isSelected() {
    return _.includes(this.args.selectedStandardIds, get(this, "args.standard.id"))
  }

  @computed("args.results.[]")
  get standardIsHidden() {
    if (this.args.results == null) return false
    return !_.includes(this.args.results, get(this, "args.standard.id"))
  }
}
